export const promiseTrue = Promise.resolve(true);
export const promiseFalse = Promise.resolve(false);
export const promiseUndefined = Promise.resolve(undefined);
export const promiseVoid = Promise.resolve();
